import type { Step } from 'react-joyride';

export const steps: Step[] = [
  {
    target: '#sales-details',
    content: 'Informações e agilidade, do jeitinho que você gosta. Adicionamos alguns recursos para ajudar na sua gestão de vendas. Confira:',
  },
  {
    target: '#sales-dash-statics',
    content: 'O que pode ser medido, pode ser melhorado. Confira os dados e estatísticas do filtro aplicado.',
    placement: 'bottom',
  },
  {
    target: '#sales-dash-toggle-tags',
    content: 'Seus resultados do seu jeito. Escolha se quer visualizar ou ocultar as tags de informações a qualquer momento.',
    placement: 'bottom',
  },
];
